module.exports = {
      id: "icon-google-play-usage",
      viewBox: "0 0 12.598 13.975",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-google-play",
      toString: function () {
        return this.url;
      }
    }